import { useMemo } from 'react';
import { hasAllPermissions, hasAnyPermission, hasPermission } from '@optiflow/shared';
import { useAuthStore } from '@/store/authStore';

/**
 * Client-side permission checks.
 *
 * These decide what to *render*. They are a usability affordance, never a security boundary —
 * every request is authorised again by the API, which is the only place the answer counts.
 */
export function usePermissions() {
  const grants = useAuthStore((state) => state.user?.permissions);

  return useMemo(
    () => ({
      can: (permission: string) => hasPermission(grants, permission),
      canAny: (permissions: string[]) => hasAnyPermission(grants, permissions),
      canAll: (permissions: string[]) => hasAllPermissions(grants, permissions),
      grants: grants ?? [],
    }),
    [grants],
  );
}
